import * as Sentry from '@sentry/react';

export const getChecklistFromLocalStorage = instructionId => {
  let checklist;

  const checklistJSON = localStorage.getItem(`checklist_${instructionId}`);

  try {
    checklist = JSON.parse(checklistJSON);
  } catch (err) {
    Sentry.captureException(err);
    localStorage.setItem(`checklist_${instructionId}`, '');
  }

  return checklist || {};
};

export const saveChecklistToLocalStorage = (instructionId, checklist) => {
  localStorage.setItem(`checklist_${instructionId}`, JSON.stringify(checklist));
};

export const clearChecklistFromLocalStorage = instructionId => {
  localStorage.removeItem(`checklist_${instructionId}`);
};
